var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureArrowRightBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32.5,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-180 32 32.5)",
    fill: "#1776EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5584 20.9369C13.6291 21.0097 13.7133 21.0675 13.8059 21.107C13.8986 21.1464 13.9981 21.1667 14.0985 21.1667C14.1989 21.1667 14.2983 21.1464 14.391 21.107C14.4837 21.0675 14.5678 21.0097 14.6385 20.9369L18.4418 17.0518C18.513 16.9795 18.5696 16.8936 18.6082 16.7989C18.6469 16.7042 18.6667 16.6027 18.6667 16.5001C18.6667 16.3975 18.6469 16.2959 18.6082 16.2013C18.5696 16.1066 18.513 16.0206 18.4418 15.9484L14.6385 12.0633C14.5678 11.9904 14.4837 11.9326 14.391 11.8932C14.2983 11.8537 14.1989 11.8334 14.0985 11.8334C13.9981 11.8334 13.8986 11.8537 13.8059 11.8932C13.7133 11.9326 13.6291 11.9904 13.5584 12.0633C13.4871 12.1355 13.4305 12.2214 13.3919 12.3161C13.3533 12.4108 13.3334 12.5124 13.3334 12.6149C13.3334 12.7175 13.3533 12.8191 13.3919 12.9138C13.4305 13.0085 13.4871 13.0944 13.5584 13.1666L16.8292 16.5001L13.5584 19.8335C13.4871 19.9058 13.4305 19.9917 13.3919 20.0864C13.3533 20.1811 13.3334 20.2826 13.3334 20.3852C13.3334 20.4878 13.3533 20.5894 13.3919 20.684C13.4305 20.7787 13.4871 20.8647 13.5584 20.9369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureArrowRightBtn);
export default __webpack_public_path__ + "static/media/feature_arrow_right_btn.6aa1a45c4508a1015a3f7ec575622836.svg";
export { ForwardRef as ReactComponent };